module.exports = __webpack_public_path__ + "static/media/no-data-icon.c2dbc427.svg";